<div class="flex-center pe-2">
  <nb-toggle [disabled]="disabled" class="size-{{size}}" [status]="status" [(ngModel)]="checked" (change)="onChangeClick($event)" [class.disabled]="disabled" >
    <ng-content></ng-content>
  </nb-toggle>
</div>

